import { useEffect, useRef, useState } from "react";
import { Checkbox } from "antd";
import { Check, FileText, LockKeyhole } from "lucide-react";

import type { LegalDocumentChallenge } from "@/domain/auth";
import { documentConfirmed } from "./acceptance";

export function LegalReader({
  document,
  label,
  onChange,
}: {
  document: LegalDocumentChallenge;
  label: string;
  onChange: (ready: boolean) => void;
}) {
  const scroller = useRef<HTMLDivElement>(null);
  const [read, setRead] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const node = scroller.current;
    if (!node) return;
    const mark = () => {
      if (node.scrollHeight - node.clientHeight <= 8) setRead(true);
    };
    mark();
    const observer = new ResizeObserver(mark);
    observer.observe(node);
    return () => observer.disconnect();
  }, [document.body_html]);

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  useEffect(() => {
    onChangeRef.current(documentConfirmed(read, checked));
  }, [read, checked]);

  return <section className="legal-reader-block" aria-labelledby={`legal-reader-${document.version_id}`}>
    <div className="legal-reader-head"><div className="legal-reader-title"><span className="legal-reader-icon"><FileText size={16} aria-hidden="true" /></span><div><b id={`legal-reader-${document.version_id}`}>{document.title}</b><small>{document.key}</small></div></div><span className="legal-reader-version">v{document.version_number}</span></div>
    <div
      ref={scroller}
      className="legal-reader"
      tabIndex={0}
      onScroll={(event) => {
        const node = event.currentTarget;
        if (node.scrollTop + node.clientHeight >= node.scrollHeight - 8) setRead(true);
      }}
      dangerouslySetInnerHTML={{ __html: document.body_html }}
    />
    <div className="legal-reader-footer"><span className={`legal-reader-read-state${read ? " is-ready" : ""}`} aria-hidden="true">{read ? <Check size={14} /> : <LockKeyhole size={14} />}</span><Checkbox checked={checked} disabled={!read} onChange={(event) => setChecked(event.target.checked)}>{label}</Checkbox></div>
  </section>;
}
